<div class="container-info">
  <div class="container-info-img" *ngIf="imgSrc">
    <div class="h-100 d-flex align-items-center">
      <img src="assets/icons/{{ imgSrc }}.svg" alt="{{ title | translate }}" />
    </div>
  </div>
  <div class="title-block">
    <h5 [ngClass]="{ 'd-none d-md-block': hideTitleOnMobile }" *ngIf="!!title">
      {{ title | translate }}
    </h5>
    <div class="isf-actions">
      <ng-content></ng-content>
    </div>
  </div>
  <p *ngIf="!!subTitle" class="sub-title text-left">
    <span class="sub-title-bold" [innerHtml]="subTitleAttention | translate"></span>
    <span [innerHtml]="subTitle | translate"></span>

    <app-hint-tooltip-icon *ngIf="!!hint" [hint]="hint | translate"></app-hint-tooltip-icon>
  </p>
</div>
